/**
 * Convert a Uint8Array of bytes to a base64 string (no data URL prefix).
 * Browser first (btoa), with Node/SSR fallback.
 */
export function bytesToBase64(bytes: Uint8Array): string {
  if (!bytes || bytes.length === 0) return '';
  if (typeof btoa === 'function') {
    let binary = '';
    const chunkSize = 0x8000; // 32KB
    for (let i = 0; i < bytes.length; i += chunkSize) {
      const chunk = bytes.subarray(i, i + chunkSize);
      binary += String.fromCharCode.apply(null, Array.from(chunk));
    }
    return btoa(binary);
  }
  return Buffer.from(bytes).toString('base64');
}
